import { render } from "./ExamPaymentMethod.vue?vue&type=template&id=2abab058"
import script from "./ExamPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ExamPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__